<template>
    <div>
        <v-text-field v-model="loop.bpm" label="BPM"></v-text-field>
        <v-textarea v-model="loop.description" rows="3" filled label="Describe your Loop"></v-textarea>
        <v-file-input v-model="loop.cover" prepend-icon="mdi-camera" label="Upload Loop Cover" accept="image/*" filled :loading="uploadingState.uploadingLoopCover"></v-file-input>
        <v-file-input v-model="loop.demo" prepend-icon="mdi-music-note" label="Upload Demo" accept="audio/mp3" filled dense :loading="uploadingState.uploadingDemo">
        </v-file-input>
        <v-file-input v-model="loop.stemZip" prepend-icon="mdi-music-note" label="Upload Stem .zip File" accept="application/zip" filled dense :loading="uploadingState.uploadingStemZip"></v-file-input>
        <v-file-input v-model="loop.stems" prepend-icon="mdi-music-note" label="Upload Stems" accept="audio/mp3" chips multiple filled dense :loading="uploadingState.uploadingLoops">
            <template v-slot:selection="{ text, index }">
                <v-chip small label dark close color="#a644b6" width="300px" @click:close="removeStem(index)">{{ text }}</v-chip>
            </template>
        </v-file-input>
    </div>
</template>
<script>
    export default {
      name: 'LoopSubmission',
      props: {
        value: {
          type: Object,
          required: true
        },
        uploadingState: {
          type: Object,
        },
        index: {
          type: Number
        }
      },
      computed: {
        loop: {
          get() { return this.value },
          set(loop) { this.$emit('input', loop) }
        }
      },
      watch: {
        loop: {
          handler(newVal) {
            this.$emit('input', newVal);
          },
          deep: true
        }
      },
      methods: {
        removeStem(index) {
          this.loop.stems.splice(index, 1)
        }
      }
    }
</script>